import { BarChart3 } from "lucide-react";

interface SummaryField<T> {
  key: keyof T | string;
  label: string;
  render?: (value: any, run: T) => React.ReactNode;
  className?: string;
}

interface BatchSummaryProps<T> {
  run: T;
  fields: SummaryField<T>[];
  columns?: number;

  // 👇 Header customization
  title?: string;
  icon?: React.ReactNode;
  headerClassName?: string;
  titleClassName?: string;
}


export function BatchSummary<T>({
  run,
  fields,
  columns = 3,
  title = "Batch Summary",
  icon = <BarChart3 className="w-5 h-5 text-blue-600" />,
  headerClassName = "flex items-center",
  titleClassName = "text-xl font-semibold text-gray-900",
}: BatchSummaryProps<T>) {
  return (
    <div className="mb-6">
      {/* Header (customizable) */}
      <div className={headerClassName}>
        {icon}
        <h2 className={titleClassName}>{title}</h2>
      </div>

      {/* Dynamic Grid */}
      <div
        className={`grid gap-x-6 gap-y-4 grid-cols-1 md:grid-cols-2 lg:grid-cols-${columns}`}
      >
        {fields.map((field) => {
          const value = run[field.key];
          return (
            <div
              key={String(field.key)}
              className={`bg-white p-3 rounded-lg `}
            >
              <p className={`text-xs uppercase ${field.className ?? "text-gray-500"}`}>{field.label}</p>
              <div className={`font-inter text-lg font-semibold ${field.className ?? "text-gray-900"} `}>
                {field.render ? field.render(value, run) : String(value ?? "-")}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

